/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BankAndTypeCard } from '../models/BankAndTypeCard';
import type { ChangeStatusRequest } from '../models/ChangeStatusRequest';
import type { ListResponse_AuthCardInfo_ } from '../models/ListResponse_AuthCardInfo_';
import { request as __request } from '../core/request';

export class CardsService {

    /**
     * @param requestBody
     * @returns string Ok
     * @throws ApiError
     */
    public static async changeCardStatus(
        requestBody: ChangeStatusRequest,
    ): Promise<string> {
        const result = await __request({
            method: 'POST',
            path: `/cards/change/status`,
            body: requestBody,
            errors: {
                400: `Validation Failed`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param cardNumber
     * @returns BankAndTypeCard Ok
     * @throws ApiError
     */
    public static async checkCardNumber(
        cardNumber: string,
    ): Promise<BankAndTypeCard> {
        const result = await __request({
            method: 'GET',
            path: `/cards/check/number/${cardNumber}`,
            errors: {
                400: `Validation Failed`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async checkCardsActive(): Promise<any> {
        const result = await __request({
            method: 'GET',
            path: `/cards/check/active`,
            errors: {
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @returns ListResponse_AuthCardInfo_ Ok
     * @throws ApiError
     */
    public static async getCardsList(): Promise<ListResponse_AuthCardInfo_> {
        const result = await __request({
            method: 'GET',
            path: `/cards/list`,
            errors: {
                400: `Validation Failed`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

}